<template>
  <SiteDailyWorkRecord />
</template>

<script>
import SiteDailyWorkRecord from './SiteDailyWorkRecord.vue'

export default {
  name: 'SiteDailyWorkRecordIndex',
  components: {
    SiteDailyWorkRecord
  }
}
</script>
